<template>
  <svg
    class="step"
    width="58px"
    height="29px"
    viewBox="1753 1201 58 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Four"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(1753.000000, 1201.000000)"
    >
      <path
        d="M0,0 L47,0 L56.5285516,12.8928447 C57.1845443,13.7804521 57.1849069,15.2190573 56.5285516,16.1071553 L47,29 L0,29 L0,0 Z"
        id="Rectangle-55"
        fill="#4990E2"
      />
      <path
        d="M22.774,15.618 L21.586,15.618 L21.586,8.256 L18.94,8.256 L13,16.338 L14.026,18.228 L18.508,18.228 L18.508,21 L21.586,21 L21.586,18.228 L22.774,18.228 L22.774,15.618 Z M16.492,15.654 L18.778,12.396 L18.742,15.654 L16.492,15.654 Z"
        id="4"
        fill="#FFFFFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StepFourIcon'
}
</script>
